import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  isSidebarHiddenSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  isSidebarHidden: Observable<boolean> = this.isSidebarHiddenSubject.asObservable();

  constructor() { }

  /**
   * Changes the visibility of the sidebar
   * @param value boolean
   *
   * @usageNotes passing true value will hide the sidebar
   * and passing false value will show the sidebar on left side of screen
   */
  changeSidebarVisiblity(value: boolean): void {
    this.isSidebarHiddenSubject.next(value);
  }
}
